"use client";

import React from "react";
import styles from "./TopBar.module.css";
import TopBarStats from "src/components/LayoutDefault/TopBarStats";
import SearchBarDesktop from "../SearchBarDesktop";

const TopBar: React.FC = () => {
  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          <TopBarStats />
        </div>
        <div className={styles.rightSection}>
          <SearchBarDesktop />
        </div>
      </div>
    </div>
  );
};

export default TopBar;
